import ReadMore from "@stimulus-components/read-more"

// Connects to data-controller="read-more"
export default class extends ReadMore {
  static targets = ["label"]

  connect() {
    super.connect();

    const isOverflowing = ({ clientWidth, clientHeight, scrollWidth, scrollHeight }) => {
      return scrollHeight > clientHeight || scrollWidth > clientWidth;
    }
    if (isOverflowing(this.contentTarget)) {
      this.contentTarget.nextElementSibling.classList.remove("hidden");
    }
  }

  show(event) {
    this.open = true;

    const toggleButton = this.contentTarget.nextElementSibling;
    if (toggleButton) {
      this.labelTarget.textContent = this.lessTextValue;
      toggleButton.setAttribute("aria-expanded", "true");
    }

    this.contentTarget.classList.remove("line-clamp-3");
    this.contentTarget.classList.add("line-clamp-none");
  }

  hide(event) {
    this.open = false;

    const toggleButton = this.contentTarget.nextElementSibling;
    if (toggleButton) {
      this.labelTarget.textContent = this.moreTextValue;
      toggleButton.setAttribute("aria-expanded", "false");
    }

    this.contentTarget.classList.add("line-clamp-3");
    this.contentTarget.classList.remove("line-clamp-none");
  }
}
